import * as React from "react";

import { useIntersectionObserver } from "../hooks";

import {
  useProductListLoadingState,
  useProductListPagination,
  useProductListPagination_asController,
  useProductListState,
} from "../providers";

const MAX_AUTOLOADS = 2;

export const ProductMasonryPaginationContainer: React.FunctionComponent = (
  props
) => {
  const { isLoading: isTheProductListLoading } = useProductListLoadingState();
  const { selectedOptions, selectedSortingOption } = useProductListState();
  const { hasMorePages, hasPreviousPages } = useProductListPagination();
  const { loadMore, loadPrevious } = useProductListPagination_asController();

  const [numberOfNextAutoLoads, setNumberOfNextAutoLoads] = React.useState(0);

  const [nextButtonRef, nextButtonEntry] = useIntersectionObserver();

  const onAutoLoadNext = () => {
    if (numberOfNextAutoLoads < MAX_AUTOLOADS) {
      loadMore();
      setNumberOfNextAutoLoads(numberOfNextAutoLoads + 1);
    }
  };

  /**
   * Uncomment the following code to enable auto-loading of the next page
   */
  // React.useEffect(() => {
  //   if (!!nextButtonEntry?.isIntersecting) {
  //     onAutoLoadNext();
  //   }
  // }, [nextButtonEntry]);

  React.useEffect(() => {
    setNumberOfNextAutoLoads(0);
  }, [selectedSortingOption, selectedOptions]);

  return (
    <div className="product-masonry-pagination-container">
      {!isTheProductListLoading && hasPreviousPages && (
        <button className="load-previous" onClick={loadPrevious}>
          LOAD PREVIOUS
        </button>
      )}
      {props?.children}
      {!isTheProductListLoading && hasMorePages && (
        <button ref={nextButtonRef} className="load-more" onClick={loadMore}>
          LOAD MORE
        </button>
      )}
    </div>
  );
};
